import BackendService from './BackendService';

export default class FormService {
  static getForms(dealerId) {
    const params = { dealerId };
    return BackendService.get('/formTemplates/all', { params });
  }

  static getForm(formId) {
    return BackendService.get(`/formTemplates/${formId}`);
  }

  static createForm(form) {
    return BackendService.post('/formTemplates', { body: form });
  }

  static updateForm(form) {
    return BackendService.put(`/formTemplates/${form.id}`, {
      body: form,
    });
  }

  static editForm(formId, changes) {
    return BackendService.post(`/formTemplates/${formId}/edit`, {
      body: { changes },
    });
  }

  static deleteForm(formId) {
    return BackendService.delete(`/formTemplates/${formId}`);
  }

  static readForms(dealId) {
    const params = {
      dealId,
    };
    return BackendService.get('/forms/getForms', { params });
  }

  static updateAlreadyFilledForm(dealId, formData) {
    return BackendService.post(`/deals/${dealId}/saveForm`, {
      formData,
    });
  }
}
